const cities = [
  {
    name: 'Hong Kong',
    photographer: 'Manson Yim',
    photographerURL: 'https://unsplash.com/@mansonyms',
    photoURL: 'https://unsplash.com/photos/lYDOrOkR_GU',
    photoDescription:
      'Cityscape of the Victoria Harbour region of Hong Kong during a magical sunset.',
    imageFile: 'hongkong.jpg',
  },
  {
    name: 'Bangkok',
    photographer: 'Nomadic Julien',
    photographerURL: 'https://unsplash.com/@nomadicjulien',
    photoURL: 'https://unsplash.com/photos/YstUCUNSGOs',
    photoDescription:
      'Phra Maha Chedi Si Rajakarn, a group of 4 large pagodas in Wat Pho, one of the oldest Buddhist temples in Bangkok, Thailand.',
    imageFile: 'bangkok.jpg',
  },
  {
    name: 'Macau',
    photographer: 'Simon Zhu',
    photographerURL: 'https://unsplash.com/@smnzhu',
    photoURL: 'https://unsplash.com/photos/9hdn4bjpmgM',
    photoDescription:
      'A view of Macau (Portguese spelling, with Macao being the English spelling) and its iconic Grand Lisboa Hotel towering in the background.',
    imageFile: 'macau.jpg',
  },
  {
    name: 'Singapore',
    photographer: 'Sreehari Devadas',
    photographerURL: 'https://unsplash.com/@sreeharid1',
    photoURL: 'https://unsplash.com/photos/vbNZravxNJo',
    photoDescription:
      'Flower Dome and Cloud Forest conservatories in Gardens by the Bay, a nature park and Singapore\'s effort to create a "City in the Garden."',
    imageFile: 'singapore.jpg',
  },
  {
    name: 'London',
    photographer: 'Alex Azabache',
    photographerURL: 'https://unsplash.com/@alexazabache',
    photoURL: 'https://unsplash.com/photos/W1Y4Y_DBGKw',
    photoDescription:
      'Big Ben, a tower clock located in the Palace of Westminster in London, England.',
    imageFile: 'london.jpg',
  },
  {
    name: 'Paris',
    photographer: 'Anthony Delanoix',
    photographerURL: 'https://unsplash.com/@anthonydelanoix',
    photoURL: 'https://unsplash.com/photos/Q0-fOL2nqZc',
    photoDescription:
      'The Eiffel Tower in Paris France, built to commemorate the centennial of the French Revolution.',
    imageFile: 'paris.jpg',
  },
  {
    name: 'Dubai',
    photographer: 'ZQ Lee',
    photographerURL: 'https://unsplash.com/@zqlee',
    photoURL: 'https://unsplash.com/photos/VbDjv8-8ibc',
    photoDescription:
      'The Burj Khalifa in Dubai, United Arab Emirates, the tallest structure and building in the world since 2009.',
    imageFile: 'dubai.jpg',
  },
  {
    name: 'Delhi',
    photographer: 'Darklabs India',
    photographerURL: 'https://unsplash.com/@darklabsindia',
    photoURL: 'https://unsplash.com/photos/wwEE3qtFtvU',
    photoDescription:
      'The Safdarjung Tomb in Delhi, India, the last monumental tomb garden of the Mughal Empire.',
    imageFile: 'delhi.jpg',
  },
  {
    name: 'Istanbul',
    photographer: 'Meriç Dağlı',
    photographerURL: 'https://unsplash.com/@meric',
    photoURL: 'https://unsplash.com/photos/xmZ7nuqK7kg',
    photoDescription:
      'An early morning view of Bosphorus Bridge and Buyuk Mecidiye Mosque in Istanbul, Turkey.',
    imageFile: 'istanbul.jpg',
  },
  {
    name: 'Kuala Lumpur',
    photographer: 'Thana Gu',
    photographerURL: 'https://unsplash.com/@guphotos',
    photoURL: 'https://unsplash.com/photos/seV_YKdhSM0',
    photoDescription:
      "A different view of the Petronas Twin Towers in Kuala Lumpur, Malaysia, the world's tallest twin skyscrapers.",
    imageFile: 'kualalumpur.jpg',
  },
];

export default cities;
